import { computed } from 'vue'
import { freezeObject } from '@/global/utils/utils'

const TAB_KEY = 'tags-configuration'
const API_CONFIG = freezeObject({
  get: {
    module: 'road-maintenance',
    route: 'tags/incoming-request-types'
  },
  post: {
    module: 'road-maintenance',
    route: 'tags/incoming-request-types'
  }
})

export function useTagsConfiguration (options) {
  const {
    tagsConfigurationComponent,
    trans
  } = options || {}

  const getLinkedTypeIds = (incomingRequestTypes = []) => {
    if (!Array.isArray(incomingRequestTypes)) {
      return []
    }

    return incomingRequestTypes
      .filter(item => item?.linked === true || item?.linked === 1 || item?.linked === '1' || item?.linked === 'true')
      .map(item => item?.incoming_request_type_id)
      .filter(id => id !== undefined && id !== null && id !== '')
  }

  const getTagTypeIds = (tag = {}) => {
    if (Array.isArray(tag?.incoming_request_type_ids)) {
      return tag.incoming_request_type_ids
    }

    return getLinkedTypeIds(tag?.incoming_request_types)
  }

  const modifyDataBeforeSend = (event) => {
    const { jsonData } = event || {}
    const tags = Array.isArray(jsonData?.tags)
      ? jsonData.tags
      : (Array.isArray(jsonData?.data?.tags) ? jsonData.data.tags : [])

    return {
      tags: tags
        .filter(tag => tag?.id !== undefined && tag?.id !== null && tag?.id !== '')
        .map(tag => ({
          id: tag.id,
          incoming_request_type_ids: getTagTypeIds(tag)
        }))
    }
  }

  const breadcrumbs = computed(() => ({
    items: [
      {
        text: trans('road-maintenance.settings')
      },
      {
        text: trans('road-maintenance.tags_configuration'),
        bolded: true
      }
    ]
  }))

  return computed(() => ({
    tabs: [
      {
        title: trans('road-maintenance.tags_configuration'),
        key: TAB_KEY,
        apiConfig: API_CONFIG,
        modifyDataBeforeSend,
        tabContent: [
          {
            component: tagsConfigurationComponent
          }
        ]
      }
    ],
    breadcrumbs: breadcrumbs.value
  }))
}
